var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoGreenOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_linear_info-circle",
    "data-name": "vuesax/linear/info-circle",
    transform: "translate(-364 -252)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "info-circle",
    transform: "translate(364 252)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9,18A9,9,0,1,0,0,9,9.026,9.026,0,0,0,9,18Z",
    transform: "translate(2 2)",
    fill: "none",
    stroke: "#09a047",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M0,0V5",
    transform: "translate(11 7.158)",
    fill: "none",
    stroke: "#09a047",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M0,0H.009",
    transform: "translate(10.995 14.667)",
    fill: "none",
    stroke: "#09a047",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M0,0H22V22H0Z",
    fill: "none",
    opacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoGreenOutline);
export default __webpack_public_path__ + "static/media/info-green-outline.6dfc00c4212835a471a81c11879817bb.svg";
export { ForwardRef as ReactComponent };